export default "__VITE_ASSET__BSpQHTzU__"